import { SlidersHorizontal } from 'lucide-react';
import { FormikErrors } from 'formik';

import { PrivateRegistryFieldsetWrapper } from '@/react/edge/edge-stacks/ItemView/EditEdgeStackForm/PrivateRegistryFieldsetWrapper';

import { Card } from '@@/primitives/Card';

import { ArtifactConfig } from '../../types';

export function RegistryConfiguration({
  values,
  setFieldValue,
  errors,
  onRegistryError,
}: {
  values: ArtifactConfig;
  errors: FormikErrors<ArtifactConfig> | undefined;
  setFieldValue: <K extends keyof ArtifactConfig>(
    f: K,
    v: ArtifactConfig[K]
  ) => void;
  onRegistryError: (message: string) => void;
}) {
  return (
    <Card.Container>
      <Card.Header title="Registry configuration" icon={SlidersHorizontal} />
      <Card.Body>
        <PrivateRegistryFieldsetWrapper
          value={values.registryId}
          onChange={(value) => setFieldValue('registryId', value)}
          values={{}}
          onFieldError={onRegistryError}
          isGit
          error={errors?.registryId}
        />
      </Card.Body>
    </Card.Container>
  );
}
